export const orderHashSchema = {
    id: '/orderHashSchema',
    type: 'string',
    pattern: '^0x[0-9a-fA-F]{64}$',
};



// WEBPACK FOOTER //
// ./~/0x.js/src/schemas/order_hash_schema.ts